import http from './http'

const authService = {
    login(data) {
        return http.post('./modules/User/UserRouter.php?c=auth', data)
    },

    requestPasswordReset(identifier) {
        return http.post('./modules/User/UserRouter.php?c=requestPasswordReset', {
            identifier
        })
    },

    resetPassword(token, password, passwordConfirm) {
        return http.post('./modules/User/UserRouter.php?c=resetPassword', {
            token,
            password,
            passwordConfirm
        })
    }
}

export default authService


// WEBPACK FOOTER //
// ./src/js/services/auth.js